import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

// Confirmación con resumen antes de ejecutar (regla de botones del módulo).
export function ConfirmarAccion({ abierto, onCerrar, titulo, accion, onConfirmar, testid, children }) {
  return (
    <AlertDialog open={abierto} onOpenChange={(v) => !v && onCerrar()}>
      <AlertDialogContent data-testid={testid}>
        <AlertDialogHeader>
          <AlertDialogTitle>{titulo}</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="text-sm text-slate-600">{children}</div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testid}-cancelar`}>Cancelar</AlertDialogCancel>
          <AlertDialogAction data-testid={`${testid}-aceptar`} onClick={() => { onCerrar(); onConfirmar(); }}>
            {accion}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
